var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlipChartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_186_2108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "27-Report"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45 4.5H30V1.5C30 1.23478 29.8946 0.98043 29.7071 0.792893C29.5196 0.605357 29.2652 0.5 29 0.5H19C18.7348 0.5 18.4804 0.605357 18.2929 0.792893C18.1054 0.98043 18 1.23478 18 1.5V4.5H3C2.20435 4.5 1.44129 4.81607 0.87868 5.37868C0.31607 5.94129 0 6.70435 0 7.5L0 37.5C0 37.7652 0.105357 38.0196 0.292893 38.2071C0.48043 38.3946 0.734784 38.5 1 38.5H23V40.5H22C21.7348 40.5 21.4804 40.6054 21.2929 40.7929C21.1054 40.9804 21 41.2348 21 41.5V47.5C21 47.7652 21.1054 48.0196 21.2929 48.2071C21.4804 48.3946 21.7348 48.5 22 48.5H26C26.2652 48.5 26.5196 48.3946 26.7071 48.2071C26.8946 48.0196 27 47.7652 27 47.5V41.5C27 41.2348 26.8946 40.9804 26.7071 40.7929C26.5196 40.6054 26.2652 40.5 26 40.5H25V38.5H47C47.2652 38.5 47.5196 38.3946 47.7071 38.2071C47.8946 38.0196 48 37.7652 48 37.5V7.5C48 6.70435 47.6839 5.94129 47.1213 5.37868C46.5587 4.81607 45.7957 4.5 45 4.5ZM25 46.5H23V42.5H25V46.5ZM46 36.5H2V34.5H46V36.5ZM46 32.5H2V7.5C2 7.23478 2.10536 6.98043 2.29289 6.79289C2.48043 6.60536 2.73478 6.5 3 6.5H25V4.5H20V2.5H28V5.5C28 5.76522 28.1054 6.01957 28.2929 6.20711C28.4804 6.39464 28.7348 6.5 29 6.5H45C45.2652 6.5 45.5196 6.60536 45.7071 6.79289C45.8946 6.98043 46 7.23478 46 7.5V32.5Z",
    fill: "#083844"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39 10.5H33V12.5H36.59L30.59 18.5H16C15.8684 18.4992 15.738 18.5245 15.6161 18.5742C15.4943 18.624 15.3835 18.6973 15.29 18.79L7.29004 26.79L8.70004 28.2L16.41 20.5H31C31.1316 20.5008 31.2621 20.4755 31.3839 20.4258C31.5058 20.376 31.6166 20.3027 31.71 20.21L38 13.91V16.5H40V11.5C40 11.2348 39.8947 10.9804 39.7071 10.7929C39.5196 10.6054 39.2653 10.5 39 10.5Z",
    fill: "#083844"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_2108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipChartIcon);
export default __webpack_public_path__ + "static/media/flip-chart-icon.6850f7e00b270fe8b286a78a028964e4.svg";
export { ForwardRef as ReactComponent };